import { useContext, useState } from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import { Container } from "components/styled/Grid"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import { Plus } from "components/icons/plus"
import { Minus } from "components/icons/minus"
import { sendEvent } from "scripts/GoogleAnalytics"
import { CarContext } from "../../CarContext"

const Wrapper = styled(Container)`
  background: ${({ theme }) => theme.colors.white};
  height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  transition: height 0.5s, opacity 0.5s, padding 0.5s;
  .show & {
    height: auto;
    opacity: 1;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: solid 1px ${({ theme }) => theme.colors.silver};
  }
`

const Title = styled(Typography)`
  margin: 0;
  max-width: 90%;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Dropdown = styled.div`
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.5s, opacity 0.5s;
  &.active {
    max-height: 400px;
    opacity: 1;
  }
`

const Text = styled(Typography)`
  font-weight: 400;
  margin-top: 1.5rem;
`

export default function Faq(props) {
  const { question, answer } = props
  const { page } = useContext(CarContext)

  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    if (!isOpen) sendEvent("faq", { event_category: page, event_label: question })
    setIsOpen(!isOpen)
  }

  return (
    <Wrapper>
      <Header onClick={toggle}>
        <Title color="skyBlue" weight="medium">
          {question}
        </Title>
        <Icon color="deepPink" size="xs" Icon={isOpen ? Minus : Plus} />
      </Header>
      <Dropdown className={isOpen ? "active" : ""}>
        <Text variant="small">{answer}</Text>
      </Dropdown>
    </Wrapper>
  )
}

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired
}
